import axios from "axios";
import Config from "../utils/Config";

class PartnerApiService {
  constructor() {
    this.baseUrl = Config.API_BASE_URL;
  }

  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  initiateDraft(payload) {
    
    return axios.post(`${this.baseUrl}/draft/initiate`, payload, this.getHeaders());
  }

  getDraftByCode(draftCode) {
    return axios.get(`${this.baseUrl}/registration/get_draft/${encodeURIComponent(draftCode)}`, this.getHeaders());
  }

  saveFullRegistration(payload) {
    return axios.post(`${this.baseUrl}/draft/save`, payload, this.getHeaders());
  }

}

const partnerApiService = new PartnerApiService();
export default partnerApiService;
